import { apiFetch } from "./api";

export const getMeetingDates = async (quarterly, year) => {
    const obj = {
        method: 'POST',
        body: {
            quarterly,
            year,
            option: 'get_meetings',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
